import React, {Component} from 'react';
import NavigatorMain from '../NavigatorMain';
import { hashHistory } from 'react-router';
import './ModelEvaluationcopy.css'

export default class ModelEvaluation extends Component{
	constructor(props){
		super(props);
		this.state = {
			agreeIndex:0,
			StateChange:true
		}
	}

	componentDidMount(){
        this.setState({
            StateChange: true
        })
	}

	handleOk(){
		this.setState({
            StateChange: false
        })
	}
	isAgreeClick(){
    let { agreeIndex } =this.state;
	    if (agreeIndex==0) {
	      this.setState({
	        agreeIndex:1
	      })
	    } else {
	      this.setState({
	        agreeIndex:0
	      })
	    }
	}
	render(){
		return (
            this.state.StateChange?
            <div className = "containerQue">
						{/* <NavigatorMain>
							<div className="header black">
								<div onClick={hashHistory.goBack}><span className="headerLeftBtn"></span></div>
								<div>公募答题问卷</div>
								<div></div>
							</div>
          </NavigatorMain> */}
					<div style={{justifyContent: 'center',display: "flex" ,flex: 1,}}>
						<div className ='modalViewQue'>
							<div   className = "titleTextQue">
								<p className = "Less">
								&emsp;&emsp;为落实《证券期货投资者适当性管理办法》，将适当的产品或服务销售或提供给适当的投资人，维护投资者合法权益，现需对您的风险承受能力进行测试，特提示如下：
								</p>
								<p className = "Less">
								&emsp;&emsp;1、当您的基本信息和风险测评问卷中的信息发生重要变化、可能影响分类时，您应及时修改基本信息或更新问卷。
								</p>
								<p className = "Less">
								&emsp;&emsp;2、本公司根据您提供的信息对您进行风险承受能力评估，开展适当性工作。您应当如实提供相关信息及证明材料，并对所提供的信息和证明材料的真实性、准确性、完整性负责。当您的各项状况发生重大变化时，您需对所投资的金融产品及时进行重新审视，以确保您的投资决定与您可承受的投资风险程度以及投资目标等实际情况一致。
								</p>
								<p className = "Less">
								&emsp;&emsp;3、投资风险承受能力测试内容及结果仅供参考，实际投资请慎重。市场有风险，投资需谨慎。
								</p>
							</div>

						<div className ='footViewQue' >
								<div className ='onPressRightView2' onClick = {()=>{this.handleOk()}}>
									<p className ='footTextR'>我已知晓并同意</p>
								</div>
						</div>
					</div>
				</div>
			</div>
				:
				<div></div>
		);
	}

};


// WEBPACK FOOTER //
// ./src/components/Modal/ModelEvaluationcopy.js